import { render, staticRenderFns } from "./MemberImage.vue?vue&type=template&id=72900d98"
import script from "./MemberImage.vue?vue&type=script&lang=js"
export * from "./MemberImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports